import React, { useState } from 'react';
import './modal.css'
import CloseMenuIcon from '../icons/closeMenuIcon';


/*
    Modal component
    props:
        - id: string, id for the modal dialog
        - title: string, title for the modal dialog to show in the header
        - show: bool, show or hide the modal dialog
        - onClose: () => void
            callback to signal user requested that the dialog be closed. 
        - buttons: [] array of button elements to be shown in the dialog footer
*/



const Modal = (props) => {
    return (
    // The Modal
    props.show
    ? <div id={props.id} className="cmis-modal">
    
        {/* Modal content  */}
        <div className="cmis-modal-content shadowed">
            <div className="cmis-modal-content-header">
                <span className="cmis-modal-title">{props.title}</span>
                <a onClick={() => props.onClose()}>
                    <CloseMenuIcon 
                        className="cmis-modal-close"
                        title="Close Dialog"
                    />
                </a>
            </div>
            <div className="cmis-modal-content-container">
                {props.children}
            </div>  
            <div className="cmis-modal-content-footer">
                {
                    props.buttons
                }
            </div>
        </div>
    
    </div>
    : null
    );
}


export default Modal;